/*
 * $Id:: UAMultiFilter.js 2021/02/26 06:09 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import React, { useState, useEffect } from 'react';

import { Paper } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import Chip from '@material-ui/core/Chip';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import { makeStyles, rgbToHex } from '@material-ui/core/styles';
import Filter1OutlinedIcon from '@material-ui/icons/Filter1Outlined';
import Filter2OutlinedIcon from '@material-ui/icons/Filter2Outlined';
import Filter3OutlinedIcon from '@material-ui/icons/Filter3Outlined';
import Filter4OutlinedIcon from '@material-ui/icons/Filter4Outlined';
import Filter5OutlinedIcon from '@material-ui/icons/Filter5Outlined';
import Filter6OutlinedIcon from '@material-ui/icons/Filter6Outlined';
import Filter7OutlinedIcon from '@material-ui/icons/Filter7Outlined';
import Filter8OutlinedIcon from '@material-ui/icons/Filter8Outlined';
import Filter9OutlinedIcon from '@material-ui/icons/Filter9Outlined';
import Filter9PlusOutlinedIcon from '@material-ui/icons/Filter9PlusOutlined';
import Popover from '@material-ui/core/Popover';

import CaretSingle from '../../assets/images/caret_single.svg';
import { ReactComponent as CheckedCheckbox } from '../../assets/images/checked_checkbox.svg';
import { t } from '../../providers';

const useStyles = makeStyles((theme) => ({
    valueWithChip: {
        display: 'flex',
        alignItems: 'center',
        height: '100%',
    },
    textInput: {
        height: '2rem',
        width: 'auto',
        marginRight: '10px',
        backgroundColor: '#ffffff',
        border: '1px solid #9B9B9B',
        marginBottom: '10px',
        marginLeft: 0,
        '& .MuiButton-label': {
            color: theme.palette.text.chipgrey,
            fontStyle: 'normal',
            fontWeight: '400',
            fontSize: '0.875rem',
            lineHeight: '142%',
            letterSpacing: '-0.2px',
        },
        '&:focus-visible': {
            backgroundColor: 'rgba(209, 224, 194, 0.2)',
            outline: 'none',
            border: '2px dashed #4F7E1D',
            borderRadius: '3px',
        },
        '@media (max-width:1100px)': {
            marginBottom: '20px !important',
        },
        '& .MuiSelect-select': {
            borderRadius: '4px',
            paddingRight: '31px',
            '&:focus-visible': {
                backgroundColor: 'rgba(209, 224, 194, 0.2)',
                outline: 'none',
                border: '2px dashed #4F7E1D',
                borderRadius: '3px',
            },
        },
        '@media (max-width:600px)': {
            width: '100%',
            marginBottom: '8px',
        },
        '& .MuiSelect-icon': {
            top: 'calc(50% - 6px)',
        },
    },
    chip: {
        color: '#3F5E20',
        height: '22px',
        display: 'block',
        boxShadow: 'none',
        zIndex: '99',
        paddingRight: '0px',
        background: '#fff',
        textAlign: 'end',
        '& .MuiChip-label': {
            padding: 0,
            display: 'none',
        },
        '& .MuiChip-icon': {
            color: '#3F5E20',
        },
        '@media (max-width:600px)': {},
    },
    filterSelect: {
        '@media (max-width:600px)': {
            width: '75%',
        },
        '& .MuiList-padding': {
            paddingTop: '0px',
            position: 'relative',
        },
        '& .MuiList-padding::after': {
            content: '""',
            display: 'block',
            width: '100%',
            height: '1rem',
            background: 'rgb(255,255,255)',
            background: 'linear-gradient(0deg, rgba(255,255,255,1) 25%, rgba(255,255,255,0.5) 70%, rgba(255,255,255,0.17226959143032183) 100%)',
            position: 'absolute',
            bottom: 0,
        },
    },
    filterBtnOptions: {
        float: 'right',
        padding: '17px 17px 17px 0px',
    },
    selectBody: {
        maxHeight: 186,
        overflow: 'auto',
        width: 274,
        boxShadow: 'none',
        paddingTop: '15px',
        '&::after': {
            content: '""',
            display: 'block',
            width: '100%',
            height: '1rem',
            background: 'rgb(255,255,255)',
            background: 'linear-gradient(0deg, rgba(255,255,255,1) 25%, rgba(255,255,255,0.5) 70%, rgba(255,255,255,0.17226959143032183) 100%)',
            position: 'absolute',
            bottom: 66,
        },
        '& .MuiListItem-root': {
            '&:focus-visible': {
                backgroundColor: 'rgba(209, 224, 194, 0.2)',
                outline: 'none',
                border: '2px dashed #4F7E1D',
                borderRadius: '3px',
            },
        },
        '@media (max-width:1100px)': {
            width: '100%',
        },
        '&::-webkit-scrollbar': {
            width: 7,
        },
        '&::-webkit-scrollbar-track': {
            backgroundColor: '#D9D9D9',
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#B8B8B8',
            borderRadius: '3px',
        },
        '& .MuiMenu-list': {
            paddingTop: '0px',
        },
        '& .MuiMenuItem-root': {
            paddingTop: '8px',
            paddingBottom: '8px',
            fontSize: '0.875rem',
            fontStyle: 'normal',
            fontWeight: '400',
            lineHeight: '142%',
            letterSpacing: '-0.2px',
            color: '#2E2E2E',
            height: 'auto',
            wordBreak: 'break-word',
            whiteSpace: 'normal',
        },
        '& .MuiIconButton-root': {
            padding: '0px 9px',
            color: '#949494',
        },
    },
    '@-moz-document url-prefix()': {
        selectBody: {
            width: 296,
        },
    },
    applyButton: {
        height: '32px',
        minWidth: '4.5rem',
        color: theme.palette.text.mainGreen,
        border: '1px solid' + theme.palette.text.mainGreen,
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        borderRadius: '2px',
        lineHeight: '12px',
        '&:focus-visible': {
            backgroundColor: 'rgba(209, 224, 194, 0.2)',
            outline: 'none',
            border: '2px dashed #4F7E1D',
            borderRadius: '3px',
        },
    },
    cancelButton: {
        height: '32px',
        minWidth: '4.5rem',
        color: theme.palette.text.chipgrey,
        border: 'none',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        borderRadius: '2px',
        lineHeight: '12px',
        '&:focus-visible': {
            backgroundColor: 'rgba(209, 224, 194, 0.2)',
            outline: 'none',
            border: '2px dashed #4F7E1D',
            borderRadius: '3px',
        },
    },
    textLabel: {
        '&:before': {
            verticalAlign: 'middle',
            position: 'relative',
        },
    },
    filterIcon: {
        paddingLeft: '10px',
    },
    filterUl: {
        padding: 0,
        margin: 0,
    },
}));

const UAMultiFilter = ({ filter = {}, handleFilterChange }) => {
    const classes = useStyles();
    const [tempSelectedOptions, setTempSelectedOptions] = useState(filter.value || []);
    const [displayOptionsList, setDisplayOptionsList] = useState([]);
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const { value, _selectedItems, filterOptions, placeholder, multiple, ...props } = filter;
    const displayOption = (option) => {
        let filterValue = { key: '', label: '' };
        if (typeof option === 'string') {
            filterValue = { key: option, label: option };
        } else if (typeof option === 'object') filterValue = { key: option.key, label: t(option.label) };
        return filterValue;
    };

    const chipIcon = [
        <Filter1OutlinedIcon aria-hidden="true" focusable="false" />,
        <Filter2OutlinedIcon aria-hidden="true" focusable="false" />,
        <Filter3OutlinedIcon aria-hidden="true" focusable="false" />,
        <Filter4OutlinedIcon aria-hidden="true" focusable="false" />,
        <Filter5OutlinedIcon aria-hidden="true" focusable="false" />,
        <Filter6OutlinedIcon aria-hidden="true" focusable="false" />,
        <Filter7OutlinedIcon aria-hidden="true" focusable="false" />,
        <Filter8OutlinedIcon aria-hidden="true" focusable="false" />,
        <Filter9OutlinedIcon aria-hidden="true" focusable="false" />,
    ];

    const addObjToArray = (arr, obj) => {
        const resultArr = (arr || []).filter((arrObj) => !obj.includes(arrObj));
        if (resultArr.length === arr.length) resultArr.push(...obj);
        return resultArr;
    };

    const handleSelect = (event) => {
        setTempSelectedOptions(addObjToArray(tempSelectedOptions, event.target.value));
    };

    const arrayEquals = (a, b) => {
        return Array.isArray(a) && Array.isArray(b) && a.length === b.length && a.every((val) => b.includes(val));
    };

    const applyFilter = () => {
        if (
            !(!Array.isArray(filter.value) && !tempSelectedOptions.length) ||
            (Array.isArray(filter.value) && !arrayEquals(tempSelectedOptions, filter.value))
        ) {
            const translatable = filterOptions.some((option) => typeof option === 'object');
            const optionSelected = translatable
                ? filterOptions
                      .filter(({ key }) => tempSelectedOptions.includes(key))
                      .map(({ label, key }) => !!key && t(label))
                      .filter((item) => typeof item === 'string') //remove non-strings from values
                : tempSelectedOptions;
            handleFilterChange({ target: { name: filter.name, value: tempSelectedOptions } }, optionSelected);
        }
        setAnchorEl(null);
    };

    const cancelFilter = () => {
        setAnchorEl(null);
        setTempSelectedOptions(filter && filter.value ? filter.value : []);
    };

    const sortFilterOptions = (filterOptions, isRequestNames, sortWithSelected = false) => {
        return (filterOptions || [])
            .map((option) => displayOption(option))
            .sort(function (a, b) {
                if (sortWithSelected) {
                    if (tempSelectedOptions.includes(a.key) && tempSelectedOptions.includes(b.key)) {
                        return tempSelectedOptions.indexOf(a.key) - tempSelectedOptions.indexOf(b.key);
                    } else if (tempSelectedOptions.includes(a.key)) {
                        return -1;
                    } else if (tempSelectedOptions.includes(b.key)) {
                        return 1;
                    } else {
                        return t(a.label).localeCompare(t(b.label));
                    }
                } else {
                    if (isRequestNames) {
                        if (t(a.label) < t(b.label)) {
                            return -1;
                        }
                        if (t(a.label) > t(b.label)) {
                            return 1;
                        }
                        return 0;
                    }
                }
            });
    };

    const handleOpen = (event) => {
        const isRequestNames = filter.name === 'requestNames';
        if (!!tempSelectedOptions.length) {
            setDisplayOptionsList(sortFilterOptions(filterOptions, isRequestNames, true));
        } else {
            setDisplayOptionsList(sortFilterOptions(filterOptions, isRequestNames, false));
        }
        setAnchorEl(event.currentTarget);
    };

    useEffect(() => {
        setTempSelectedOptions(filter && filter.value ? filter.value : []);
    }, [filter]);

    const handleClose = () => {
        setTempSelectedOptions(filter && filter.value ? filter.value : []);
        setAnchorEl(null);
    };

    let otherProps = { ...props };
    otherProps = { ...otherProps, filterid: undefined };

    return (
        <>
            <Button
                aria-haspopup="true"
                aria-controls={`filter-input-${filter.name}-menu`}
                aria-label={
                    !!tempSelectedOptions.length
                        ? `${t(placeholder)}: ${tempSelectedOptions.length} ${t('filters.applied')}`
                        : `${t('filter.by')} ${t(placeholder)}`
                }
                aria-expanded={open}
                onClick={handleOpen}
                {...otherProps}
                id={`filter-input-${filter.name}`}
                className={`${classes.textInput} ${classes.selectWidth}`}
                disableFocusRipple>
                {value && !!value.length ? (
                    <span className={classes.valueWithChip}>
                        <span style={{ color: '#3F5E20', fontWeight: '400' }}>{t(placeholder)}</span>
                        <Chip
                            className={classes.chip}
                            label={multiple ? value.length : '1'}
                            icon={value.length <= 9 ? chipIcon[value.length - 1] : <Filter9PlusOutlinedIcon aria-hidden="true" focusable="false" />}
                        />
                    </span>
                ) : (
                    <>
                        <span>{t(placeholder)}</span>
                        <img src={CaretSingle} alt="" className={classes.filterIcon} />
                    </>
                )}
            </Button>
            <Popover
                getContentAnchorEl={null}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                id={`filter-input-${filter.name}-menu`}
                anchorEl={anchorEl}
                aria-labelledby={`filter-input-${filter.name}`}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': `filter-input-${filter.name}`,
                    role: 'listbox',
                }}>
                <Paper className={classes.selectBody}>
                    <ul className={classes.filterUl}>
                        {displayOptionsList.map((filterValue, idx) => {
                            return (
                                <MenuItem
                                    style={{ alignSelf: 'start' }}
                                    id={`filter-${filter.name}-option-${idx}`}
                                    key={`${filterValue.key}_${idx}`}
                                    value={!multiple && idx === 0 ? '' : filterValue.key}
                                    onKeyDown={(event) => {
                                        if (event.key === 'Enter') {
                                            handleSelect({ target: { name: filter.name, value: [filterValue.key] } });
                                        }
                                    }}
                                    onClick={() => {
                                        handleSelect({ target: { name: filter.name, value: [filterValue.key] } });
                                    }}>
                                    <Checkbox
                                        disableFocusRipple
                                        checkedIcon={<CheckedCheckbox />}
                                        checked={(tempSelectedOptions || []).indexOf(filterValue.key) > -1}
                                        style={{ alignSelf: 'start' }}
                                        inputProps={{
                                            'aria-label': filterValue.label,
                                        }}
                                    />
                                    {filterValue.label}
                                </MenuItem>
                            );
                        })}
                    </ul>
                </Paper>
                <div className={classes.filterBtnOptions}>
                    <Button id={'cancelButton'} onClick={cancelFilter} className={classes.cancelButton} disableRipple disableFocusRipple>
                        {t('cancel.tab.title')}
                    </Button>
                    <Button id={'applyButton'} onClick={applyFilter} className={classes.applyButton} disableRipple disableFocusRipple>
                        {t('apply.button.text')}
                    </Button>
                </div>
            </Popover>
        </>
    );
};

export default UAMultiFilter;
